import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderInteger,
  renderDropdown,
  renderYesNo,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
} from "./RenderUtils";

export class ReplaceVehicleRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          <label className="quote-change-label">OLD VEHICLE</label>
          {renderInteger(
            "oldVehicleYear",
            "Vehicle Year",
            request,
            updateRequest,
            "e.g. 1958",
            { ignoreServerValidation: true }
          )}
          {renderTextBox(
            "oldVehicleMake",
            "Vehicle Make",
            request,
            updateRequest,
            "Ford"
          )}
          {renderTextBox(
            "oldVehicleModel",
            "Vehicle Model",
            request,
            updateRequest,
            "Pinto"
          )}
          {renderTextBox(
            "oldVehicleVin",
            "Vehicle VIN Number",
            request,
            updateRequest,
            "VIN123456789"
          )}
          {renderTextBox(
            "oldVehicleType",
            "Vehicle Type",
            request,
            updateRequest
          )}
          <label className="quote-change-label">NEW VEHICLE</label>
          {renderInteger(
            "newVehicleYear",
            "Vehicle Year",
            request,
            updateRequest,
            "e.g. 1958",
            { ignoreServerValidation: true }
          )}
          {renderTextBox(
            "newVehicleMake",
            "Vehicle Make",
            request,
            updateRequest,
            "Ford"
          )}
          {renderTextBox(
            "newVehicleVin",
            "Vehicle VIN Number",
            request,
            updateRequest,
            "VIN123456789"
          )}
          {renderTextBox(
            "newGaragingCity",
            "Garaging City",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderDropdown(
            "newRegistrationState",
            "Registration State",
            request,
            updateRequest,
            this.props.states
          )}
          {renderTextBox(
            "newLegalEntity",
            "Legal Entity",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderTextBox(
            "newDriversLicenseNumber",
            "Driver's License Number",
            request,
            updateRequest,
            "E.g. Placeholder text"
          )}
          {renderYesNo(
            "doesVehicleHavePhysicalDamageCoverage",
            "Does Vehicle have physical damage coverage?",
            request,
            updateRequest
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
